import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=65741aac"
import script from "./Defects.vue?vue&type=script&lang=ts"
export * from "./Defects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports